import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';
import swal, {default as Swal} from 'sweetalert2';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {NgWizardService} from 'ng-wizard';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentTypeService} from '../../../service/document-type.service';
import {DocumentDetailsService} from '../../../service/document-details.service';
import {DocumentPage} from '../../../shared/dto/document-page';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {BlacklistService} from '../../../shared/service/blacklist.service';
import {AppConfig} from '../../../shared/common/app.config';
declare var $: any;
declare var scanner: any;


/*
  Fully re-enhanced the component by - Sajith Henarath
  sajith_h@epic.net

 */



@Component({
  selector: 'app-upload-sid-scan',
  templateUrl: './upload-sid-scan.component.html',
  styleUrls: ['./upload-sid-scan.component.scss']
})
export class UploadSidScanComponent implements OnInit {
  @Input() sidNo:string;

  documentUploadFrom: FormGroup;
  public loader: boolean = false;
  public pages: DocumentPage = new DocumentPage();
  public saveObj: DocumentPage = new DocumentPage();
  public selectedValue: string;
  showPanel: boolean=false;
  user: string;
  error: boolean = false;
  sucess: boolean = false;
  documentDetails: any = [];
  files: File[] = [];
  addedFiles: File[] = [];
  documentTypes: any = [];
  selectedImage: any = [];
  savedImages: any = [];
  filesId: number;
  tagName: string;
  docIdies: any = [];
  docId: number;


  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              public applicantRequestService: ApplicantRequestService,
              public documentTypeService: DocumentTypeService,
              private spinnerService: NgxUiLoaderService,
              private documentDetailsService: DocumentDetailsService,
              private tokenStorageService: TokenStorageService,
              private blackListService: BlacklistService,
              private appConfig: AppConfig) {
  }


  ngOnInit() {
    this.documentUploadFrom = new FormGroup({
      document_type: new FormControl('')
    });
    this.onLoadDocumentType();
    this.user = this.tokenStorageService.getUserObjectToken().username;
  }



  scanToJpg(maxPage, scanid, server, contextPath, session) {
    let docId = 0;

    if (this.docIdies.length > 0)
      docId = this.docIdies[0];

    var val = scanner.isConnectedToScanWebSocket()

    if (val) {

      scanner.scan(function (successful, mesg, response) {
          this.displayImagesOnPage(successful, mesg, response);
        }.bind(this),
        {
          "req_param":
            {
              "scanid": scanid,
              "documentID": docId,
              "server": server,
              "contextPath": contextPath,
              "sessionid": session,
              "username": "test",
              "maxpage": maxPage,
              "uploadUrl": this.appConfig.getConfig('BASE_URL') + "/api/documentscan/upload_scan_doc"
            }
        }
      );

    } else {
      scanner.displayInstallScanAppEnableJavaPopup(true);
    }
    this.refresh();
  }

  displayImagesOnPage(successful, mesg, response) {
    var self = this;
    if(successful){
      var response = $.parseJSON(mesg)
      if (response.STATUS) {
        var docdata = $.parseJSON(response.RESPONSE);
        this.docId = docdata.DOCUMENTID;

        this.docIdies.push(this.docId);
        this.getDocumentDetailsFromDocumentId(docdata.DOCUMENTID);

        this.refresh();

      }
    }
  }

  refresh(){

    if (this.docIdies.length >= 1) {
        this.getDocumentDetailsFromDocumentId(this.docIdies[0]);

    }

  }

  onScan() {
    this.scanToJpg(20,'cdca137fcdf64167ac7d24add977928f',
      'localhost',
      'EPIC_SIS',
      '584ce6f070ebf5cf869596413bb2');

  }

  onSubmit(element) {
    this.spinnerService.start();
    const formData: FormData = new FormData();
    formData.append('file', element);

    this.applicantRequestService.uploadFiles(formData).subscribe(
      (result: any) => {
        this.spinnerService.stop();
        this.filesId = +result.result;

        this.getDocumentDetailsFromDocumentId(result.result);
        swal.fire(result.messageStatus, result.message, result.messageClass);
      }, (error) => {
        console.error(error);
        this.spinnerService.stop();
      }
    );
  }

  onSelect(event) {
    this.addedFiles.push(...event.addedFiles);
    this.files.push(...event.addedFiles);

  }

  onUpload() {
    if (this.files.length >= 1) {
      console.log('Files count when uploading : ' + this.files.length);

      this.spinnerService.start();
      const formData: FormData = new FormData();
      for (let file of this.files) {
        formData.append('files', file, file.name);
      }

      if (this.docIdies.length > 0)
        formData.append('documentId', this.docIdies[0]);
      else
        formData.append('documentId', '0');

      this.applicantRequestService.uploadPrintedSIDFiles(formData).subscribe(
        (result: any) => {
          this.spinnerService.stop();

          if (result.status == 'Error') {
            swal.fire(
              'Error',
              result.message,
              'error'
            );
          } else {
            this.docIdies.push(result.documentId);
            this.refresh();
            this.addedFiles = [];
            this.files = [];

            swal.fire(
              'Success',
              'Files Successfully uploaded',
              'success'
            );
          }

        }
      );

    } else {
      swal.fire(
        'Warning',
        'Please select at least one document to upload',
        'warning'
      );
    }
  }

  onRemove(event) {
    console.log(event);
    this.addedFiles.splice(this.addedFiles.indexOf(event), 1);
  }

  onLoadDocumentType() {
    this.documentTypeService.getAllDocumentType().subscribe(
      (result: any) => {
        this.documentTypes = result;
      }
    );
  }

  getSavedDocumentDetailsFromDocumentId(id) {
    this.documentDetailsService.getAllDocumentType(id).subscribe(
      (result: any) => {
        result.forEach(element => {
          this.documentDetails.push(element);
        });
      }
    );
  }

  onSelectImage(item) {
    if (this.selectedImage.includes(item)) {
      // remove
      const index = this.selectedImage.indexOf(item);

      if (index > -1) {
        this.selectedImage.splice(index, 1);
      }

    } else {
      this.selectedImage.push(item);
    }
    console.log(this.selectedImage);
    this.selectedValue = this.documentUploadFrom.controls['document_type'].value;
  }


  saveDocumentTypeAndDetails() {
    if (this.documentUploadFrom.value.document_type !== '') {
      const document_type1 = this.documentUploadFrom.controls['document_type'].value;

      const copyOfDetails = [...this.documentDetails];

      if (this.docIdies.length > 0)
        this.saveObj.fileId = this.docIdies[0];

      this.saveObj.pageList = this.selectedImage;
      this.saveObj.tagName=this.documentUploadFrom.value.document_type;
      this.saveObj.user=this.user;
      this.saveObj.sid=this.sidNo;

      this.tagName = this.documentUploadFrom.value.document_type;

      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to save card image?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.showPanel=false;
          this.documentDetailsService.saveSidScan(this.saveObj).subscribe(
            (success: string) => {
              let myMap = new Map();

              copyOfDetails.forEach(element => {
                myMap.set(element.document.documentId, element.document.documentId);
              });

              myMap.forEach(element => {
                this.getSavedDocumentDetailsFromDocumentId(element);
              });

              swal.fire('Success', 'Document Uploaded Successfully', 'success');
              this.error=false;
              this.showPanel=false;
              this.files=[];
            },
            (error) => {
              swal.fire('Error', 'Error When Uploading the Image', 'error');
              this.sucess=false;
            },
          );
        } else {
        }
      });

    } else {
      swal.fire('error', 'Select a Document Type', 'error');
    }
  }

  getDocumentDetailsFromDocumentId(id) {

    if (this.documentDetails.length > 0)
      this.documentDetails = [];

    this.documentDetailsService.getAllDocumentType(id).subscribe(
      (result: any) => {
        result.forEach(element => {
          this.documentDetails.push(element);
        });
      }
    );
    this.showPanel=true;
  }

}
